import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectHydrationFinished } from 'app/hooks/reduxCreateSelectorHooks';
const EarlyFeatureAccessFab = /*#__PURE__*/React.lazy(() => import('app/components/earlyFeatureAccess/EarlyFeatureAccessFab'));
const EarlyFeatureAccessFabLoader = () => {
  const hydrationFinished = useSelector(selectHydrationFinished);
  return hydrationFinished ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: null,
    "data-sentry-element": "Suspense",
    "data-sentry-component": "EarlyFeatureAccessFabLoader",
    "data-sentry-source-file": "EarlyFeatureAccessFabLoader.tsx"
  }, /*#__PURE__*/React.createElement(EarlyFeatureAccessFab, {
    "data-sentry-element": "EarlyFeatureAccessFab",
    "data-sentry-source-file": "EarlyFeatureAccessFabLoader.tsx"
  })) : null;
};
export default EarlyFeatureAccessFabLoader;